import newMessageSound from '@/assets/audio/new-message.mp3'

export const playNewMessageSound = () => {
  const audio = new Audio(newMessageSound)
  audio.addEventListener('canplaythrough', () => audio.play())
}
